// services
import { Http } from "@shared/svelte/Modules/ApiService";

// stores
import { autoPaySettingsStore } from "@retailer/svelte/stores/AutoPaySettingsStore";

// types
import type { HTTPParams } from "@shared/types/HTTP";

const baseUrl = "/api/retailer/auto_pay_settings";

const makeReq = async (requestData, successCB) => {
  const errCB = () => {
    autoPaySettingsStore.update(autoPaySettings => ({
      ...autoPaySettings,
      loaded: true,
      failed: true,
    }));
  };

  autoPaySettingsStore.update(autoPaySettings => ({
    ...autoPaySettings,
    loaded: false,
    failed: false,
  }));

  await Http(requestData, successCB, errCB);
};

export const get = async () => {
  const requestData: HTTPParams = {
    method: "GET",
    url: baseUrl,
  };

  const successCB = json => {
    autoPaySettingsStore.set({
      loaded: true,
      failed: false,
      autoPaySettings: json,
    });
  };

  makeReq(requestData, successCB);
};

export const create = async (
  paymentInstrumentId: number,
  distributorIds: number[],
  useCredits: boolean,
  onSuccess: () => void
) => {
  const requestData: HTTPParams = {
    method: "POST",
    url: baseUrl,
    data: {
      payment_instrument_id: paymentInstrumentId,
      distributor_ids: distributorIds,
      use_credits: useCredits,
    },
  };

  const successCB = () => {
    get();
    onSuccess();
  };

  makeReq(requestData, successCB);
};

export const update = async (
  autoPaySettingId: number,
  paymentInstrumentId: number,
  distributorIds: number[],
  useCredits: boolean,
  onSuccess: () => void
) => {
  const url = `${baseUrl}/${autoPaySettingId}`;
  const requestData: HTTPParams = {
    method: "PUT",
    url: url,
    data: {
      payment_instrument_id: paymentInstrumentId,
      distributor_ids: distributorIds,
      use_credits: useCredits,
    },
  };

  const successCB = () => {
    get();
    onSuccess();
  };

  makeReq(requestData, successCB);
};
